import { useState, useEffect } from 'react';

export const useDevices = () => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  
  useEffect(() => {
    const getDevices = () => navigator.mediaDevices.enumerateDevices().then(newDevices => setDevices(newDevices)).catch(e => console.log(e));

    navigator.mediaDevices.addEventListener('devicechange', getDevices);
    getDevices();

    // Hack for making sure device lists update after permissions are allowed
    const checkDevicesInterval = setInterval(async () => {
      getDevices();
    },  5000);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', getDevices);
      clearInterval(checkDevicesInterval);
    };
  }, []);

  return {
    audioInputDevices: devices.filter(device => device.kind === 'audioinput'),
    videoInputDevices: devices.filter(device => device.kind === 'videoinput'),
    audioOutputDevices: devices.filter(device => device.kind === 'audiooutput'),
    hasAudioInputDevices: devices.filter(device => device.kind === 'audioinput').length > 0,
    hasVideoInputDevices: devices.filter(device => device.kind === 'videoinput').length > 0,
  };
}
